export default function(ac, app) {
    var entity = app.getEntity('OznakaBoje');

    entity.listView()
        .title('Oznake boja')
        .icon('<i class="fa fa-eur fa-3x"></i>')
        .fields([
            ac.field('boja', 'reference')
                .label('Boja')
                .targetEntity(app.getEntity('Boja'))
                .targetField(ac.field('naziv'))
                .cssClasses(['col-md-9']),
            ac.field('oznaka')
                .cssClasses(['col-md-2']),
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    entity.editionView()
        .title('Boja')
        .fields([
            {
                key:'boja',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Boja',
                    required: true,
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite boju',
                    options: [],
                    focus: true
                },
                controller: ['$scope', 'DS', function ($scope, DS) {
                    DS.findAll('Boja').then(function (response) {
                        $scope.to.options = response;
                    });
                }]
            },
            {
                key:'oznaka',
                type: 'hInput',
                templateOptions: {
                    label: 'Oznaka',
                    required: true
                }
            }
        ]);

    return entity;
}



// WEBPACK FOOTER //
// ./app/components/oznakaBoje/config.js